import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const AlertIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.142 13.414L17.23 13.825L17.23 13.825L18.142 13.414ZM5.858 13.414L6.77 13.825H6.77L5.858 13.414ZM5.122 15.042L4.211 14.63V14.63L5.122 15.042ZM18.878 15.042L19.789 14.63L19.789 14.63L18.878 15.042ZM10.183 19.269C9.779 18.892 9.146 18.914 8.769 19.317C8.392 19.721 8.414 20.354 8.817 20.731L10.183 19.269ZM15.183 20.731C15.586 20.354 15.608 19.721 15.231 19.317C14.854 18.914 14.221 18.892 13.817 19.269L15.183 20.731ZM17.543 16H6.457V18H17.543V16ZM6.034 15.454L6.77 13.825L4.947 13.002L4.211 14.63L6.034 15.454ZM7.663 9.692V8.133H5.663V9.692H7.663ZM16.337 8.133V9.692H18.337V8.133H16.337ZM17.23 13.825L17.966 15.454L19.789 14.63L19.053 13.002L17.23 13.825ZM16.337 9.692C16.337 11.116 16.642 12.523 17.23 13.825L19.053 13.002C18.58 11.956 18.337 10.83 18.337 9.692H16.337ZM6.77 13.825C7.358 12.523 7.663 11.116 7.663 9.692H5.663C5.663 10.83 5.42 11.956 4.947 13.002L6.77 13.825ZM6.457 16C6.073 16 5.94 15.66 6.034 15.454L4.211 14.63C3.469 16.272 4.745 18 6.457 18V16ZM17.543 18C19.255 18 20.531 16.272 19.789 14.63L17.966 15.454C18.06 15.66 17.927 16 17.543 16V18ZM12 4C14.432 4 16.337 5.887 16.337 8.133H18.337C18.337 4.71 15.463 2 12 2V4ZM12 2C8.537 2 5.663 4.71 5.663 8.133H7.663C7.663 5.887 9.568 4 12 4V2ZM12 20C11.312 20 10.676 19.73 10.183 19.269L8.817 20.731C9.656 21.514 10.771 22 12 22V20ZM13.817 19.269C13.324 19.73 12.688 20 12 20V22C13.229 22 14.344 21.514 15.183 20.731L13.817 19.269Z"
      fill="currentColor"
    />
  </svg>
);

AlertIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(AlertIcon);
